import { ArticleLocation, StockStatusFilter } from "types";

export const stockStatusOptions: Array<{
  id: StockStatusFilter;
  label: string;
}> = [
  { id: "all", label: "Todos los estados" },
  { id: "available", label: "Disponible" },
  { id: "not_available", label: "No disponible" },
  { id: "reserved", label: "Reservado" },
  { id: "in_work_orders", label: "En OT" },
];

export const getStockStatusOption = (status: StockStatusFilter) =>
  stockStatusOptions.find((option) => option.id === status) ??
  stockStatusOptions[0];

export const getMovementArticleStockStateLabel = (
  status?: "available" | "not_available" | "reserved" | null,
) => {
  if (!status) {
    return "-";
  }

  return getStockStatusOption(status).label;
};

export const getArticleLocationQuantityByStatus = (
  articleLocation: Pick<
    ArticleLocation,
    "stock" | "reserved" | "not_available" | "in_work_orders" | "status_quantity"
  >,
  status: StockStatusFilter,
) => {
  if (articleLocation.status_quantity != null) {
    return Math.max(0, Number(articleLocation.status_quantity));
  }

  switch (status) {
    case "available":
      return Math.max(
        0,
        Number(articleLocation.stock ?? 0) -
          Number(articleLocation.reserved ?? 0) -
          Number(articleLocation.not_available ?? 0) -
          Number(articleLocation.in_work_orders ?? 0),
      );
    case "not_available":
      return Math.max(0, Number(articleLocation.not_available ?? 0));
    case "reserved":
      return Math.max(0, Number(articleLocation.reserved ?? 0));
    case "in_work_orders":
      return Math.max(0, Number(articleLocation.in_work_orders ?? 0));
    case "all":
    default:
      return Math.max(0, Number(articleLocation.stock ?? 0));
  }
};
